import React, { useEffect, useState, useRef } from 'react'
import { Container, Row, Col, Dropdown, Form, Button, Card, Spinner  } from 'react-bootstrap'
import { axiosOpen } from "../../../../api/axios.js"
import { useParams } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export default function AddCustomPrompts() {
    const navigate = useNavigate();
    const isComponentMounted = useRef(false);
    const platforms =["amazon","walmart","target"];
    const types = ["title", "bullets", "description"];
    const { promptID } = useParams();
    const userID = localStorage.userID && JSON.parse(localStorage.userID) || null;
    const editPromptForm = promptID ? true : false;
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [validated, setValidated] = useState(false);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        platform: "",
        type: "",
        prompt: ""
    });

    const handleChange = (event) => {
        setFormData({
          ...formData,
          [event.target.name]: event.target.value,
        });
    };

    function handlePlatformSelection(eventKey){
        setSelectedPlatform(eventKey);
        handleChange({target: { name: 'platform', value: eventKey } });
    }

    function handleTypeSelection(eventKey) {
        setSelectedType(eventKey);
        handleChange({target: { name: 'type', value: eventKey } });
    }

    function handleCancel() {
        navigate("/customprompts", { replace: true });
    }

    function handleSubmit(event) {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false || !formData.platform || !formData.type || !formData.prompt === "") {
            setValidated(true);
            return;
        }
        setLoader(true);
        (async()=> {
            const url = editPromptForm ? `gpt/editprompt/${userID}` : `gpt/addprompt/${userID}`;
            const requestBody = editPromptForm ? { promptid: promptID, prompt: formData.prompt.toString() } : formData;
            try {
                const response = editPromptForm ? await axiosOpen.put(url, requestBody) : await axiosOpen.post(url, requestBody);
                response.status === 200 && isComponentMounted.current && toast.success(editPromptForm ? 'Prompt updated!' : 'Prompt added!');
            } catch (error) {
                isComponentMounted.current && toast.error(error.response.data.message || "Oops! something went wrong.")
            } finally {
                setTimeout(() => navigate("/customprompts", { replace: true }), 3000)
                setLoader(false);
            }
        })();
    }

    useEffect(() => {
        isComponentMounted.current = true;
        if(editPromptForm){
            (async()=> {
                const { data } = await axiosOpen.get(`gpt/getsingleprompt/${userID}?key=${promptID}`);
                if(!isComponentMounted.current) return;
                setFormData({
                    platform: data.prompt.platform,
                    type: data.prompt.type,
                    prompt: data.prompt.prompt,
                });
                setSelectedPlatform(data.prompt.platform);
                setSelectedType(data.prompt.type);
            })();
        } else {
            isComponentMounted.current && setFormData({...formData});
        }
        return () => {
            isComponentMounted.current = false;
        }
    }, [])

    return (
      <Card className="customPromptsContainer">
        <Card.Body>
          <Container>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <h2 className="text-center mb-3">Custom Prompts</h2>
                </Col>
              </Row>
              {editPromptForm ? (
                <>
                  <Row>
                    <Col sm="12" md="2" lg="2" xl="2" xxl="2">
                      <Form.Label>Platform: </Form.Label>
                    </Col>
                    <Col sm="12" md="10" lg="10" xl="10" xxl="10">
                      {selectedPlatform}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="2" lg="2" xl="2" xxl="2">
                      <Form.Label>Type:</Form.Label>
                    </Col>
                    <Col sm="12" md="10" lg="10" xl="10" xxl="10">
                      {selectedType}
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row className="mb-2">
                    <Col
                      sm="2"
                      md="2"
                      lg="2"
                      xl="2"
                      xxl="2"
                      className="d-flex align-items-center"
                    >
                      <Form.Label>Platform</Form.Label>
                    </Col>
                    <Col sm="10" md="10" lg="10" xl="10" xxl="10">
                      <Dropdown onSelect={handlePlatformSelection}>
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          className="text-capitalize"
                        >
                          {selectedPlatform
                            ? selectedPlatform
                            : "Select platform"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {platforms.map((platform) => {
                            return (
                              <Dropdown.Item
                                eventKey={platform}
                                className="text-capitalize"
                              >
                                {platform}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      sm="2"
                      md="2"
                      lg="2"
                      xl="2"
                      xxl="2"
                      className="d-flex align-items-center"
                    >
                      <Form.Label>Type</Form.Label>
                    </Col>
                    <Col sm="10" md="10" lg="10" xl="10" xxl="10">
                      <Dropdown onSelect={handleTypeSelection}>
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          className="text-capitalize"
                        >
                          {selectedType ? selectedType : "Select Type"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {types.map((promptType) => {
                            return (
                              <Dropdown.Item
                                eventKey={promptType}
                                className="text-capitalize"
                              >
                                {promptType}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Row>
                </>
              )}
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="formPrompts">
                    <Form.Label>Prompts:</Form.Label>
                    <Form.Control
                      value={formData.prompt}
                      name="prompt"
                      type="text"
                      placeholder="Custom Prompts"
                      as="textarea"
                      rows={3}
                      onChange={handleChange}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your custom prompts.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              {editPromptForm && (
                <Row>
                  <Col className="mb-4">
                    <Card bg="danger" text="white">
                      <Card.Body className="font-weight-bold p-2">
                        NOTE: Please don't change the variables in curly braces.
                        eg: {`{{keyword}}`}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
              <Row>
                <Col className="d-flex justify-content-center align-items-center gap-3">
                  <Button
                    variant="primary"
                    type="submit"
                    className={`${loader ? "disabled" : ""}`}
                  >
                    {loader ? (
                      <>
                        <Spinner animation="border" size="sm" />{" "}
                        {editPromptForm ? "Updating.." : "Saving..."}
                      </>
                    ) : editPromptForm ? (
                      "Update"
                    ) : (
                      "Save"
                    )}
                  </Button>
                  <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
          <Toaster position="top-right" reverseOrder={false} />
        </Card.Body>
      </Card>
    );
}